import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { debounceTime, merge, startWith } from 'rxjs';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { toNum } from '@shared/helpers/math.helper';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { Utilities } from '@core/helpers/utilities';
import { formPaths } from '@shared/constants/form-paths.const';
import { controlloEventualiDiffida50PercentoVolontari, getSchedaCoopSocialiControl } from '../validators/helpers/scheda-coop-sociali-form-validators.helper';

export const setSchedaCoopSocialiSociVolontariListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_SociVolontari(form, store);
    my_CalcoloPercentSociVolont(form, store);
    my_CkSociVolontari(form, store);
    my_PercentSociVolont(form, store);
};

const my_SociVolontari = (form: FormGroup, store: Store<Revisione53State>): void => {
    const sociVolontariMaschiControl = getSchedaCoopSocialiControl(form, 'my_SociVolontariMaschi');
    const sociVolontariFemmineControl = getSchedaCoopSocialiControl(form, 'my_SociVolontariFemmine');
    const sociVolontariControl = getSchedaCoopSocialiControl(form, 'my_SociVolontari');

    merge(
        sociVolontariMaschiControl.valueChanges.pipe(startWith(sociVolontariMaschiControl.value)),
        sociVolontariFemmineControl.valueChanges.pipe(startWith(sociVolontariFemmineControl.value))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            const value = (toNum(sociVolontariMaschiControl.value) + toNum(sociVolontariFemmineControl.value)).toString(10);

            sociVolontariControl.patchValue(value, { emitEvent: false });

            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_SezioneI__Rilevazione.my_SchedaCoopSociali.my_SociVolontari = value;
                return myVerbaleClone;
            });
        });
};

const my_CalcoloPercentSociVolont = (form: FormGroup, store: Store<Revisione53State>): void => {
    const percentSociVolontControl = getSchedaCoopSocialiControl(form, 'my_PercentSociVolont');
    const sociVolontariMaschiControl = getSchedaCoopSocialiControl(form, 'my_SociVolontariMaschi');
    const sociVolontariFemmineControl = getSchedaCoopSocialiControl(form, 'my_SociVolontariFemmine');

    const ebsGroup = getGroup(form, formPaths.baseSociale);
    const sociFisCoopDataControl = getControl(ebsGroup, 'my_SociFisCoopData');
    const sociGiuCoopDataControl = getControl(ebsGroup, 'my_SociGiuCoopData');
    const sociFisFinDataControl = getControl(ebsGroup, 'my_SociFisFinData');
    const sociGiuFinDataControl = getControl(ebsGroup, 'my_SociGiuFinData');
    const sociSpecDataControl = getControl(ebsGroup, 'my_SociSpecData');

    merge(
        sociVolontariMaschiControl.valueChanges.pipe(startWith(sociVolontariMaschiControl.value)),
        sociVolontariFemmineControl.valueChanges.pipe(startWith(sociVolontariFemmineControl.value)),
        sociFisCoopDataControl.valueChanges.pipe(startWith(sociFisCoopDataControl.value)),
        sociGiuCoopDataControl.valueChanges.pipe(startWith(sociGiuCoopDataControl.value)),
        sociFisFinDataControl.valueChanges.pipe(startWith(sociFisFinDataControl.value)),
        sociGiuFinDataControl.valueChanges.pipe(startWith(sociGiuFinDataControl.value)),
        sociSpecDataControl.valueChanges.pipe(startWith(sociSpecDataControl.value))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            const denominator =
                toNum(sociFisCoopDataControl.value) +
                toNum(sociGiuCoopDataControl.value) +
                toNum(sociFisFinDataControl.value) +
                toNum(sociGiuFinDataControl.value) +
                toNum(sociSpecDataControl.value);

            const value = denominator !== 0 ? ((toNum(sociVolontariMaschiControl.value) + toNum(sociVolontariFemmineControl.value)) / denominator).toString(10) : '0';

            percentSociVolontControl.patchValue(value, { emitEvent: false });

            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_SezioneI__Rilevazione.my_SchedaCoopSociali.my_PercentSociVolont = value;
                return myVerbaleClone;
            });

            controlloEventualiDiffida50PercentoVolontari(store);
        });
};

const my_CkSociVolontari = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getSchedaCoopSocialiControl(form, 'my_CkSociVolontari');
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe(() => {
        controlloEventualiDiffida50PercentoVolontari(store);
    });
};

const my_PercentSociVolont = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getSchedaCoopSocialiControl(form, 'my_PercentSociVolont');
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe(() => {
        controlloEventualiDiffida50PercentoVolontari(store);
    });
};
